import { axiosInstance } from './axios';
import { isFailedLyskraftResponse } from './lyskraftresponse';

/**
 * PUT {base}/{id}/geofence-exception for a package or a return: approval, trimmed reason and the version the
 * operator saw. Fulfillment owns roles, facility scope, the current leg and the audit; this only refuses
 * incomplete input before transport and a response it cannot tie to the same record.
 */
/**
 * The manager's decision plus the rider and step they saw. Fulfillment refuses it when either is no longer current;
 * it never compares a record version (2026-10-29).
 */
export type GeofenceExceptionDecision = {
  approved: boolean;
  reason?: string;
  riderId: number;
  step: string;
};

export async function putGeofenceException(
  baseURL: string,
  id: number,
  payload: GeofenceExceptionDecision,
): Promise<Record<string, unknown>> {
  if (
    !Number.isInteger(id) ||
    id <= 0 ||
    !Number.isInteger(payload.riderId) ||
    payload.riderId <= 0 ||
    !payload.step ||
    typeof payload.approved !== 'boolean'
  ) {
    throw new Error('Refresh the page to see the current rider and step.');
  }
  const reason = payload.reason?.trim();
  if (payload.approved && (!reason || reason.length > 250)) {
    throw new Error('Approval reason is required (maximum 250 characters)');
  }
  const response = await axiosInstance.put(`${baseURL}/${id}/geofence-exception`, {
    approved: payload.approved,
    ...(reason ? { reason } : {}),
    riderId: payload.riderId,
    step: payload.step,
  });
  const envelope = response.data;
  if (isFailedLyskraftResponse(envelope)) {
    throw new Error(envelope.status?.message || 'Unable to update the location exception');
  }
  if (envelope?.data?.id !== id || typeof envelope.data.geofenceExceptionApproved !== 'boolean') {
    throw new Error('Response could not be verified. Refresh and check the exception.');
  }
  return envelope.data;
}
